module.exports = __webpack_public_path__ + "img/weather-haze.7ef5ea07.png";